import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getConsumptionSourceList } from '../../../slices/consumptionSource/thunk';
import AddEditConsumptionSourceModal from './Add_Edit/AddEditConsumptionSource';
import DeleteConsumptionSourceModal from './Delete/DeleteConsumptionSource';
import ConsumptionSourceFilesModal from './Modals/ConsumptionSourceFilesModal';
import { Group } from '@mantine/core';

const ConsumptionSourceList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorConsumptionSource = createSelector(
		state => state.ConsumptionSource,
		data => ({
			consumptionSourceList: data.consumptionSourceList,
			isLoadingList: data.isLoadingList,
			isConsumptionSourceSuccess: data.isConsumptionSourceSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.rolesListSelect,
	// 	rolesListSelect => rolesListSelect
	// );

	// const rolesListSelect = useSelector(selectRolesList);

	const { consumptionSourceList, isLoadingList } = useSelector(
		selectorConsumptionSource
	);

	useEffect(() => {
		dispatch(getConsumptionSourceList());
	}, []);

	const [dataConsumptionSource, setDataConsumptionSource] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete ConsumptionSource
	const [modal, setModal] = useState(false);
	const [modalMaintenance, setModalMaintenance] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [modalFilesConsumptionSource, setModalFilesConsumptionSource] =
		useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalMaintenance() {
		setModalMaintenance(!modalMaintenance);
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	function handleToggleModalFilesConsumptionSource() {
		setModalFilesConsumptionSource(!modalFilesConsumptionSource);
	}

	// Delete Data
	const handleClickDelete = consumptionSource => {
		setDataConsumptionSource(consumptionSource);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = consumptionSource => {
		setDataConsumptionSource(consumptionSource);
		handleToggleModal();
	};

	// Update Data
	const handleClickMaintenance = consumptionSource => {
		setDataConsumptionSource(consumptionSource);
		handleToggleModalMaintenance();
	};

	const handleClickFilesConsumptionSource = consumptionSource => {
		setDataConsumptionSource(consumptionSource);
		handleToggleModalFilesConsumptionSource();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'consumptionSource',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const consumptionSourceData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(consumptionSourceData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const consumptionSourceData =
														cellProps.row.original;
													handleClickDelete(consumptionSourceData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				size: 'auto',
				dataType: 'string',
			},
			{
				header: 'Tipo',
				accessorKey: 'consumption_source_type.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Tipo Combustible',
				accessorKey: 'fuel_type.name',
				size: 'auto',
				dataType: 'multi-select',
			},

			{
				header: 'Requiere Autorizacion',
				accessorKey: 'with_authorization',
				dataType: 'boolean',
				size: 'auto',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='with_authorization'
							name='with_authorization'
							disabled
							checked={row.original.with_authorization}
						/>
					);
				},
			},
			{
				header: 'Considerar Cálculo de Emisiones',
				accessorKey: 'emission_calculation',
				dataType: 'boolean',
				size: 'auto',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='emission_calculation'
							name='emission_calculation'
							disabled
							checked={row.original.emission_calculation}
						/>
					);
				},
			},
			{
				header: 'Establecimiento Responsable',
				accessorFn: row => row.establishment.map(item => item.name),
				dataType: 'multi-select',
				size: 'auto',
				mantineFilterMultiSelectProps: {
					data: [
						...new Set(
							consumptionSourceList
								?.map(item =>
									item.establishment?.map(item => item.name)
								)
								?.flat() || []
						),
					],
				},
				Cell: ({ row }) => {
					const establishment = row?.original?.establishment;

					return establishment && establishment.length ? (
						<Group spacing='xs'>
							{establishment.map(item => (
								<span
									onClick={() =>
										window.open(
											`/establishment/summary/${item._id}`,
											'_blank'
										)
									}
									style={{
										cursor: 'pointer',
										color: 'var(--vz-primary)',
										textDecoration: 'none',
										fontWeight: 'bold',
									}}
								>
									<i className='ri-links-line'></i> {item.name}
								</span>
							))}
						</Group>
					) : (
						<span>-</span>
					);
				},
			},

			{ header: 'Descripción', accessorKey: 'description' },
		],
		[handleClickEdit, handleClickDelete, handleClickFilesConsumptionSource]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataConsumptionSource({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Fuente de Consumo
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={consumptionSourceList || []}
								isLoadingData={isLoadingList}
								nameFile={'fuentes_de_consumos'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataConsumptionSource({});
											handleToggleModal();
										},
										title: 'Crear Fuente de Consumo',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditConsumptionSourceModal
				dataConsumptionSource={dataConsumptionSource}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<DeleteConsumptionSourceModal
				dataConsumptionSource={dataConsumptionSource}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ConsumptionSourceList;
